import { createApiSlice } from "@common";
import { CRUD_LMS_LEAVE_TYPE_CONGIG } from "@routes";

const apiConfig = [
  {
    name: "addLeaveType",
    method: "post",
    url: CRUD_LMS_LEAVE_TYPE_CONGIG,
    stateKey: "message"
  },
  {
    name: "getLeaveType",
    method: "get",
    url: CRUD_LMS_LEAVE_TYPE_CONGIG,
    stateKey: "data"
  },
  {
    name: "updateLeaveType",
    method: "put",
    url: CRUD_LMS_LEAVE_TYPE_CONGIG,
    stateKey: "message"
  },
  {
    name: "deleteLeaveType",
    method: "delete",
    url: CRUD_LMS_LEAVE_TYPE_CONGIG,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData:
      (state, action) => {
        state.additionalData = action.payload;
      },
  },
  extraReducers: {},
};

const { slice, thunks, actions } =
  createApiSlice("LeaveType", apiConfig, customReducers);
const LeaveTypeSlice = slice;

export default LeaveTypeSlice.reducer;

export const {
  addLeaveType,
  getLeaveType,
  updateLeaveType,
  deleteLeaveType
} = thunks;
export const {
  rowSelect
} = actions;
